import { ASANA } from '../../../constants/import-type';
import {
	DEFAULT_CONFIG,
	type StepComponent,
	IMPORT_IN_PROGRESS_STEP,
	PROJECT_CREATE_STEP,
	SELECT_THIRD_PARTY_ENTITY_STEP,
	StatisticsType,
	THIRD_PARTY_REVIEW_STEP,
	ReviewTilesType,
	SELECT_SOURCE_STEP,
	templatesJSW,
} from '../../../constants/steps';
import commonMessages from '../messages';
import messages from './messages';

export const getAsanaSteps = (hiddenUsers?: boolean): StepComponent[] => [
	{
		step: SELECT_THIRD_PARTY_ENTITY_STEP,
		overrides: {
			overrideReturnStep: SELECT_SOURCE_STEP,
		},
		stepProps: {
			thirdParty: ASANA,
			stats: hiddenUsers ? [StatisticsType.TASKS] : [StatisticsType.TASKS, StatisticsType.MEMBERS],
			hasSearchableEntities: true,
		},
		progressBarStepLabel: messages.asanaStepLabel,
	},
	{
		...DEFAULT_CONFIG,
		step: PROJECT_CREATE_STEP,
		stepProps: {
			hasProgressBar: true,
			shouldPrefillThirdPartyProjectName: true,
			shouldShowThirdPartyStats: false,
			thirdParty: ASANA,
			shouldStartImportOnNext: false,
			isTMPSupported: true,
			templates: templatesJSW,
		},
		progressBarStepLabel: commonMessages.projectCreateStepLabel,
	},
	{
		...DEFAULT_CONFIG,
		step: THIRD_PARTY_REVIEW_STEP,
		stepProps: {
			thirdParty: ASANA,
			tiles: hiddenUsers
				? [ReviewTilesType.HIERARCHY, ReviewTilesType.FIELDS, ReviewTilesType.ATTACHMENTS]
				: [
						ReviewTilesType.HIERARCHY,
						ReviewTilesType.FIELDS,
						ReviewTilesType.USERS,
						ReviewTilesType.ATTACHMENTS,
					],
		},
		progressBarStepLabel: commonMessages.reviewStepLabel,
	},
	{
		step: IMPORT_IN_PROGRESS_STEP,
		overrides: {
			overrideReturnStep: SELECT_SOURCE_STEP,
		},
		stepProps: {
			hasProgressBar: true,
			thirdParty: ASANA,
		},
		progressBarStepLabel: commonMessages.importInProgressStepLabel,
	},
];
